
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules'

Swiper.use([Navigation, Pagination, Autoplay, EffectFade])

export const HeroSlider = () => {
  const heroSliders = document.querySelectorAll('.js-heroSlider');
  if ( !heroSliders.length ) {
      return
  }

  $(document).ready(function() {
    heroSliders.forEach((heroSliderEl) => {
      const sliderEl = heroSliderEl.querySelector('.js-heroSlider__imageSliderWrapper')
      const contentSliderEl = heroSliderEl.querySelector('.js-heroSlider__contentSliderWrapper')
      if (!sliderEl || !contentSliderEl) {
        return
      }

      const slider = new Swiper(sliderEl, {
        effect: 'slide',
        autoplay: {
          delay: 3600,
          disableOnInteraction: true,
        },
        speed: 600,
        pagination: {
          el: heroSliderEl.querySelector('.c-heroSlider__pagination'),
          clickable: true,
          renderBullet: function (index, className) {
            return (
              `<span class="c-heroSlider__paginationItem ${className}">
                <span></span>
                <span>${index + 1}</span>
              </span>`
            )
          },
        },
        navigation: {
          nextEl: heroSliderEl.querySelector('.c-heroSlider__nextSlide'),
          prevEl: heroSliderEl.querySelector('.c-heroSlider__prevSlide'),
        },
      })

      const contentSlider = new Swiper(contentSliderEl, {
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        slidesPerView: 1,
        autoHeight: true,
      })

      slider.on('slideChange', () => {
        if (contentSlider.activeIndex !== slider.activeIndex) {
          contentSlider.slideTo(slider.activeIndex)
        }
      })
      contentSlider.on('slideChange', () => {
        if (slider.activeIndex !== contentSlider.activeIndex) {
          slider.slideTo(contentSlider.activeIndex)
        }
      })

      const $consentButton = heroSliderEl.querySelector('.js-heroSlider__consentButton')
      if ($consentButton) {
        const updateConsentButtonVisibility = () => {
          // Reads the cookie directly, so it's correct before cmplz-activated is set.
          const hasConsent = typeof window.cmplz_has_consent === 'function' && window.cmplz_has_consent('marketing')
          const activeSlide = slider.slides[slider.activeIndex]
          const needsConsent = !hasConsent && !!activeSlide && !!activeSlide.querySelector('.cmplz-iframe:not(.cmplz-activated)')
          $consentButton.classList.toggle('is-visible', needsConsent)
        }

        updateConsentButtonVisibility()
        slider.on('slideChange', updateConsentButtonVisibility)
        document.addEventListener('cmplz_status_change', updateConsentButtonVisibility)

        // Fallback: catches activation that fires without cmplz_status_change.
        const iframeObserver = new MutationObserver(updateConsentButtonVisibility)
        sliderEl.querySelectorAll('.cmplz-iframe').forEach((iframe) => {
          iframeObserver.observe(iframe, { attributes: true, attributeFilter: ['class'] })
        })
      }
    })
  });
}
